import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import 'moment/locale/pt-br';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './index.scss';
import omit from 'lodash/omit';
import { DateRangePicker } from 'react-dates';
import { withStyles, withStylesPropTypes } from 'react-with-styles';

const propTypes = {
  ...withStylesPropTypes,

  // example props for the demo
  autoFocus: PropTypes.bool,
  autoFocusEndDate: PropTypes.bool,
  initialStartDate: momentPropTypes.momentObj,
  initialEndDate: momentPropTypes.momentObj,
  ...omit({}, ['startDate', 'endDate', 'onDatesChange', 'focusedInput', 'onFocusChange'])
};

const defaultProps = {
  // example props for the demo
  autoFocus: false,
  autoFocusEndDate: false,
  initialStartDate: null,
  initialEndDate: null,

  // input related props
  startDateId: 'startDate',
  startDatePlaceholderText: 'Data Início',
  endDateId: 'endDate',
  endDatePlaceholderText: 'Data Fim',
  disabled: false,
  required: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // calendar presentation and interaction related props
  renderMonthText: null,
  orientation: window.innerWidth > 820 ? 'horizontal' : 'vertical',
  anchorDirection: 'left',
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: window.innerWidth < 820,
  initialVisibleMonth: null,
  numberOfMonths: 1,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,
  onPrevMonthClick() {},
  onNextMonthClick() {},
  onClose() {},

  // day presentation and interaction related props
  renderDayContents: null,
  minimumNights: 0,
  enableOutsideDays: false,
  isDayBlocked: () => false,
  isOutsideRange: () => false,
  isDayHighlighted: () => false,

  // internationalization
  displayFormat: () => moment.localeData().longDateFormat('L'),
  monthFormat: 'MMMM YYYY'
};

class DateRangePickerWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null
    };
  }

  componentDidMount() {
    const datePickers = document.getElementsByClassName('DateInput_input');
    Array.from(datePickers).forEach(el => el.setAttribute('readOnly', true));
  }

  onFocusChange = focusedInput => this.setState({ focusedInput });

  isOutsideRange = day => day.isAfter(moment()) || day.isBefore(moment().subtract(6,"months"));

  render() {
    const { focusedInput } = this.state;
    const { onDatesChange } = this.props;
    const props = omit(this.props, [
      'autoFocus',
      'autoFocusEndDate',
      'initialStartDate',
      'initialEndDate'
    ]);
    return (
      <React.Fragment>
        <DateRangePicker
          {...props}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onDatesChange={startDate => {
            onDatesChange(startDate.startDate, startDate.endDate);
          }}
          focusedInput={focusedInput}
          onFocusChange={this.onFocusChange}
          isOutsideRange={this.isOutsideRange}
        />
      </React.Fragment>
    );
  }
}

DateRangePickerWrapper.propTypes = propTypes;
DateRangePickerWrapper.defaultProps = defaultProps;

export default withStyles(({ reactDates: { color } }) => ({
  PresetDateRangePicker_panel: {
    padding: '0 22px 11px 22px'
  },

  PresetDateRangePicker_button: {
    position: 'relative',
    height: '100%',
    textAlign: 'center',
    background: 'none',
    border: `2px solid ${color.core.primary}`,
    color: color.core.primary,
    padding: '4px 12px',
    marginRight: 8,
    font: 'inherit',
    fontWeight: 700,
    lineHeight: 'normal',
    overflow: 'visible',
    boxSizing: 'border-box',
    cursor: 'pointer',

    ':active': {
      outline: 0
    }
  },

  PresetDateRangePicker_button__selected: {
    color: color.core.white,
    background: color.core.primary
  }
}))(DateRangePickerWrapper);
